import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";

import { advisorGridApi, type SkillCard } from "../api/advisorGridApi";

/**
 * 读当前用户可见的个性化 skill 网格。queryKey 带身份(tenantCode+userId)防跨用户缓存串
 * (QueryClient module 单例横跨软登出/登录存活;承 launcher C-1 教训)。
 * 挂在已过 useAdvisorAccess 门的对话面板内,故不再重复 gating。
 */
export function useSkillGrid() {
  const { user } = useAuth();
  const query = useQuery({
    queryKey: ["advisor", "skill-grid", user?.tenantCode, user?.userId],
    queryFn: () => advisorGridApi.list(),
    staleTime: 60_000,
  });
  return {
    cards: (query.data ?? []) as SkillCard[],
    loading: query.isLoading,
  };
}
